import moniveaRoadLogo from '../assets/images/moniveaRoadLogo.png';
import heydayLogo from '../assets/images/heydaylogo.svg';
import medreleafLogo from '../assets/images/medreleaf-logo.png';
import isMobile from 'ismobilejs';

const target = isMobile(window.navigator).any ? '_self' : '_blank';

const MoniveaRoadLogo = (props: { userToken?: string; isGuest: boolean }) => (
  <>
    {process.env.VITE_THEME_TOGGLE === 'HeyDay' ? (
      <div className="flex justify-start lg:justify-center items-center">
        <a href="/home" className="pr-2 xl:pr-5 border-r border-white">
          <img className="w-full xl:w-72" src={heydayLogo} alt="Heyday logo" />
        </a>
        <a
          className="ml-2 xl:ml-5 flex flex-col justify-between"
          href="https://monivearoad.com.au/"
          target={target}
          rel="noreferrer"
        >
          <span className="text-xxs xl:text-xs text-white mb-1">
            fulfilled by
          </span>
          <img
            className="w-full lg:w-3/5 xl:w-72 3xl:w-4/5"
            src={moniveaRoadLogo}
            alt="Monivea Road logo"
          />
        </a>
      </div>
    ) : process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? (
      <div className="flex justify-start lg:justify-center items-center">
        <a href="/home" className="pr-2 xl:pr-5">
          <img
            className="w-full xl:w-72"
            src={medreleafLogo}
            alt="Medreleaf Clinics logo"
          />
        </a>
        <a
          className="ml-2 xl:ml-5 flex flex-col justify-between"
          href="https://monivearoad.com.au/"
          target={target}
          rel="noreferrer"
        >
          <span className="text-xxs xl:text-xs mb-1">fulfilled by</span>
          <img
            className="w-full lg:w-3/5 xl:w-72 3xl:w-4/5"
            style={{
              // backgroundColor: '#276177',
              backgroundColor: '#818285',
              padding: '2px',
            }}
            src={moniveaRoadLogo}
            alt="Monivea Road logo"
          />
        </a>
      </div>
    ) : props?.userToken ? (
      <a
        href={`${process.env.CLIENT_APP_URL}/home`}
        className="flex justify-start lg:justify-center"
      >
        <img
          className="lg:w-3/5 xl:w-72 3xl:w-full"
          src={moniveaRoadLogo}
          alt="Monivea Road logo"
        />
      </a>
    ) : props.isGuest ? (
      <a
        href={`${process.env.CLIENT_APP_URL}/guest/shopping-products`}
        className="flex justify-start lg:justify-center"
      >
        <img
          className="lg:w-3/5 xl:w-72 3xl:w-full"
          src={moniveaRoadLogo}
          alt="Monivea Road logo"
        />
      </a>
    ) : (
      <a
        href="https://monivearoad.com.au/"
        className="flex justify-start lg:justify-center"
      >
        <img
          className="lg:w-3/5 xl:w-72 3xl:w-full"
          src={moniveaRoadLogo}
          alt="Monivea Road logo"
        />
      </a>
    )}
  </>
);

export default MoniveaRoadLogo;
